module.exports = __webpack_public_path__ + "static/media/vitality-icon.ef201bab.png";